import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'digires-checkbox',
  templateUrl: './digires-checkbox.component.html',
  styleUrls: ['./digires-checkbox.component.scss']
})
export class DigiresCheckboxComponent implements OnChanges {
  @Output() onChange = new EventEmitter<MatCheckboxChange>();

  @Input() formGroup: FormGroup;
  @Input() formCtrlName: string;
  @Input() disabled: boolean;
  @Input() tooltip: string;
  @Input() tooltipPosition: 'left' | 'right' | 'above' | 'below' | 'before' | 'after' = 'below';
  @Input() labelPosition: "before" | "after" = 'after';
  @Input() cssClasses: any;


  ngOnChanges(): void {
    const control = this.formGroup?.controls?.[this.formCtrlName];
    this.disabled ? control?.disable() : control?.enable();
  }
}
